import React, { useState } from 'react';
import { Row, Col, Button, FormCheck } from 'react-bootstrap';
import BitsyModal from '../bitsy-modal';

import './style.scss';

export default function SMSOptIn(props) {
  const [modalType, setModalType] = useState('NONE');

  const exitModal = () => setModalType('NONE');

  const renderModal = () => {
    if (modalType === 'smsOptInDetails') {
      return (
        <BitsyModal
          isShowingModal
          content='smsOptInDetails'
          onExit={exitModal}
          onClickMainButton={exitModal}
          type='bodyAndExitModal'
          h2ClassName='smsOptInTitle'
          modalHeaderClass='smsOptInModalHeader'
          data={{}}
        />
      );
    }
    return null;
  };

  const handleCheckboxToggle = async () => {
    // instead of regex
    let attentiveVisitorId;
    try {
      // eslint-disable-next-line prefer-destructuring
      attentiveVisitorId = document.cookie.split('; ').find(row => row.startsWith('__attentive_id=')).split('=')[1];
    } catch (e) {
      // no attentive id found
    }
    props.handleSMSOptInToggle(attentiveVisitorId);
  };

  return (
    <Row id={props.containerId} className='sms-optIn-container'>
      {renderModal()}
      <Col>
        <FormCheck aria-label='Edit description for SMS Account Sign Up Opt In'>
          <FormCheck.Label>
            <FormCheck.Input
              checked={props.isSmsOptInSelected}
              onChange={handleCheckboxToggle}
              name='isSmsOptInSelected'
              isStatic={false}
              id='smsOptInInput'
            />
            Text me! Get quick account alerts & updates, plus specials!
            <Button
              className='detailsButton'
              variant='incognito'
              onClick={() => setModalType('smsOptInDetails')}
            >
              Details
            </Button>
          </FormCheck.Label>
        </FormCheck>
      </Col>
    </Row>
  );
}
